import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { ChatPage } from '@/pages/Chat'
import { PortfolioPage } from '@/pages/Portfolio'
import { ProfilePage } from '@/pages/Profile'
import { SecuritiesPage } from '@/pages/Securities'
import { TradingPage } from '@/pages/Trading'

/**
 * Main App component with routing configuration.
 *
 * The v2 app is served under /v2/ base path.
 * React Router's basename handles the prefix, so routes here are relative.
 */
function App() {
  return (
    <Routes>
      {/* Main layout wrapper */}
      <Route path="/" element={<Layout />}>
        {/* Default redirect to chat */}
        <Route index element={<Navigate to="/chat" replace />} />

        {/* Chat routes */}
        <Route path="chat" element={<ChatPage />} />
        <Route path="chat/:roomId" element={<ChatPage />} />

        {/* Portfolio routes */}
        <Route path="portfolio" element={<PortfolioPage />} />

        {/* Profile routes */}
        <Route path="profile" element={<ProfilePage />} />
        <Route path="profile/:username" element={<ProfilePage />} />

        {/* Securities routes */}
        <Route path="securities" element={<SecuritiesPage />} />

        {/* Trading routes */}
        <Route path="trading" element={<TradingPage />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/chat" replace />} />
      </Route>
    </Routes>
  )
}

export default App
